module.exports = __webpack_public_path__ + "static/img/ny.c0a8b543.png";